import { css } from '@emotion/react'
import { cssVar, gemVar, Spacing, ThemedColors } from '@opallabs/gem'
import { buttonSelectors } from '../Button'
import { radixPopoverAnchorWidthVar } from '../Popover'

export const selectors = {
  root: 'lapidary-cascading-single-select',
}

export const states = {
  hasSelection: 'has-selection',
}

export const container = css({
  display: 'flex',
  flexFlow: 'column',
  gap: Spacing.XS,

  [`&:not(.${states.hasSelection}) .${buttonSelectors.buttonText}`]: {
    color: gemVar(ThemedColors.TextSecondary),
    opacity: 0.5,
  },
})

export const button = css({
  inlineSize: '100%',

  [`.${buttonSelectors.buttonContents}`]: {
    overflow: 'hidden',

    [`.${buttonSelectors.buttonText}`]: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
  },
})

export const menu = css({
  // Keeps popover content width the same as the anchor
  width: cssVar(radixPopoverAnchorWidthVar),
})
